import { render, staticRenderFns } from "./BtnCopy.vue?vue&type=template&id=3340d0f8&"
import script from "./BtnCopy.vue?vue&type=script&lang=js&"
export * from "./BtnCopy.vue?vue&type=script&lang=js&"
import style0 from "./BtnCopy.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports